import {AddObjectAction} from './AddObjectAction';

export class AddTierAction extends AddObjectAction {
  constructor(object) {
    super(object);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/actions/AddTierAction.ts